module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_5-40486c85f58a86adf24c0bda12fe1003.jpg";